export default "/fonts/vendor/material-icons/iconmaterial-icons-round.woff?5d681e2edae8c60630db51d7fbc2907b";